import React from 'react';
import Section from './section';
import SimpleReportTable, { SimpleReportTableColumn } from './simpleReportTable';
import styles from '../index.module.scss';

interface BrakingScenarioData {
    data?: any[];
    analysisDescription?: string;
}

// 制动场景分析模块
const BrakingScenarioAnalysis = (props: BrakingScenarioData) => {
    const { data = [], analysisDescription = '' } = props;

    const columns: SimpleReportTableColumn[] = [
        { title: '主要场景', dataIndex: 'scene', key: 'scene' },
        { title: '设备减速&制动次数', dataIndex: 'happen_ct', key: 'happen_ct' },
        { title: '占比', dataIndex: 'happen_rate', key: 'happen_rate' },
    ];

    // 生成分析结论
    const generateAnalysis = () => {
        if (!data || data.length === 0) return '';

        const topScenario = data[0];
        const secondScenario = data[1];

        let analysis = '';

        if (topScenario) {
            analysis += `${topScenario.scene || '前车减速'}和${secondScenario?.scene || '车辆碰撞风险'}是触发设备减速&制动的主要原因\n\n`;
            analysis += `在所有减速&制动场景中，由${topScenario.scene || '前车减速'}引起的占${topScenario.happen_rate || '58.0%'}`;

            if (secondScenario) {
                analysis += `，${secondScenario.scene || '车辆碰撞风险'}占${secondScenario.happen_rate || '42.0%'}`;
            }
        }

        return analysis;
    };

    const defaultAnalysis = generateAnalysis();
    return (
        <Section title="九、制动场景分析">
            <>
                <SimpleReportTable
                    columns={columns}
                    dataSource={data}
                    rowKey={(record, index) => record?.scene || index}
                    emptyText="暂无制动场景分析数据"
                />

                {(analysisDescription || defaultAnalysis) && (
                    <div className={styles.analysisBlock}>
                        <h4>分析结果</h4>
                        <div className={styles.analysisContent}>
                            {analysisDescription || defaultAnalysis}
                        </div>
                    </div>
                )}

                {!analysisDescription && !defaultAnalysis && data.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                        暂无制动场景分析数据
                    </div>
                )}
            </>
        </Section>
    );
};

export default BrakingScenarioAnalysis;
